/**
 * rcmApiLib Module
 */
angular.module('rcmApiLib', []);
